import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useEffect } from "react";

const Testimonial = () => {
  const reviews = [
    {
      user_profile: "https://img.freepik.com/free-photo/indian-student-man-holding-pile-books-sitting-near-fountain-street_231208-2778.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid",
      alt:'Sahil verma',
      user_name: "Sahil verma",
      message: "BrainboxStudy made learning FullStack Development so easy! I landed my dream job as a developer thanks to their step-by-step guidance.",
      rating: 5,
    },
    {
      user_profile: "https://img.freepik.com/free-photo/young-bearded-hindu-student-with-backpack-pastel-wall_496169-1524.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid",
      alt:'Harsh Sharma',
      user_name: "Harsh Sharma",
      message: "The Web Designing course was fantastic! The practical projects and expert advice gave me the confidence to start my freelance career.",
      rating: 4,
    },
    {
      user_profile: "https://img.freepik.com/premium-photo/indian-college-student-standing-with-bag-reading-book-white-background_75648-5432.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid",
      alt:'Keshav Joshi',
      user_name: "Keshav Joshi",
      message: "The Digital Marketing course helped me grow my small business online. I highly recommend BrainboxStudy to anyone looking to learn real skills.",
      rating: 5,
    },
    {
      user_profile: "https://img.freepik.com/premium-photo/man-holding-book-called-author-book_1034910-73581.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid",
      alt:'Sunny',
      user_name: "Sunny ",
      message: "I learned Python and Machine Learning from BrainboxStudy, and now I’m working on AI projects at a top company. Amazing experience",
      rating: 3,
    },
   
  ];

  useEffect(() => {
    const prevButton = document.querySelector(".custom-prev");
    const nextButton = document.querySelector(".custom-next");
    if (prevButton && nextButton) {
      prevButton.addEventListener("click", () => {
        const swiper = document.querySelector(".swiper").swiper;
        swiper.slidePrev();
      });

      nextButton.addEventListener("click", () => {
        const swiper = document.querySelector(".swiper").swiper;
        swiper.slideNext();
      });
    }
  }, []);

  return (
    <div className="py-6 bg-white ">
      <div className="max-w-7xl sm:px-6 px-4 mx-auto">
        <div className="text-center max-w-4xl mx-auto mb-8 ">
          <span className="bg-amber-500 text-white text-semibold px-6 text-[13px] py-[3px] rounded-full">Review</span>
          <h2 className="lg:text-4xl text-2xl font-semibold ">What Our Students Say</h2>
          <p className="text-base ">Our students share their success stories and how our courses helped them achieve their goals.</p>
        </div>
        <div className="relative p-[2px] bg-white shadow-sm rounded-sm  overflow-hidden">
          <div className="absolute inset-0 border shadow-xl"></div>
          <div className="relative z-10 sm:p-6 rounded-lg">
            <Swiper
             spaceBetween={30}
             slidesPerView={1}
             loop={true}
             grabCursor={true}
             autoplay={{ delay: 3000, disableOnInteraction: false }}
             breakpoints={{
               550: { slidesPerView: 1 },   
               768: { slidesPerView: 1 },   
               1024: { slidesPerView: 2 }, 
             }}
                 modules={[Autoplay, Navigation]}
             className="swiper w-full"
           >
              {reviews.map((card, index) => (
                <SwiperSlide key={index}>
                  <div className="grid md:grid-cols-3 rounded-lg shadow-lg bg-white border px-6  py-10 items-center gap-12">
                    
                    <div>
                      <img
                        src={card.user_profile}
                        className="w-[380px] rounded-lg shadow-[20px_20px_10px_rgba(23,219,220,1)]"
                        alt="Student of Brain Box Study"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <div className="text-gray-800 text-base">
                        <p className="text-sm text-justify">{card.message}</p>
                      </div>
                      <div className="mt-2">
                        <p className="text-gray-800 text-base font-semibold">
                          {card.user_name}
                        </p>
                      
                      </div>
                      <div className="flex items-center mt-4">
                        <span className="text-yellow-400 text-base">
                          {Array.from({ length: card.rating }, (_, i) => (
                            <span key={i}>★</span>
                          ))}
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="flex justify-end gap-4 mt-6">
              <button className="custom-prev bg-gray-300 hover:bg-amber-600 w-10 h-10 flex items-center justify-center rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 "
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <button className="custom-next bg-gray-300 hover:bg-amber-600 w-10 h-10 flex items-center justify-center rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 "
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.59 7.41L13.17 12l-4.58 4.59L10 18l6-6-6-6z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
 

  );
};

export default Testimonial;
